import React from "react";
import SeatRow from "./SeatRow";
import ExitRow from "./ExitRow";
import Lavatory from "./Lavatory";
import { SeatMapProps } from "./types";

const SeatMap: React.FC<SeatMapProps> = ({
  seatMap,
  onSeatSelect,
  selectedSeats = [],
  totalTravellers,
}) => {
  console.log(seatMap, "seatMap");
  return (
    <div className="seat-map bg-white p-6 rounded-lg shadow">
      {/* Front Lavatory Row */}
      <div className="flex justify-between mb-4">
        <Lavatory position="front" />
        <Lavatory position="front" />
      </div>

      {/* Exit Row */}
      <div className="flex justify-between mb-4">
        <div className="exit-icon exit-left mx-2">
          <ExitRow position="left" />
        </div>
        <div className="exit-icon exit-right mx-2">
          <ExitRow position="right" />
        </div>
      </div>

      {/* Header with column labels */}

      <div className="flex justify-between mx-4 seatRow">
        {seatMap?.map((col: any, index: any) =>
          col?.PlanColumn?.map((j: any) => (
            <div key={index} className="text-center text-sm text-gray-500">
              {j}
            </div>
          ))
        )}
      </div>

      {/* Seat Rows */}
      <div className="flightSeatMatrix">
        {seatMap?.map((row: any) =>
          row?.LstRow?.map((j: any, index: number) => (
            <>
              {/* {j?.lstColumn?.map((i: any) =>
                i?.lstFacility?.map(
                  (k: any) =>
                    k?.Type === "EXITROW" && (
                      <div className="flex justify-between mb-4">
                        <div className="exit-icon exit-left mx-2">
                          <ExitRow position="left" />
                        </div>
                        <div className="exit-icon exit-right mx-2">
                          <ExitRow position="right" />
                        </div>
                      </div>
                    )
                )
              )} */}
              <SeatRow
                key={index}
                rowData={j}
                onSeatSelect={onSeatSelect}
                selectedSeats={selectedSeats}
                totalTravellers={totalTravellers}
                PlanColumn={row.PlanColumn}
              />
            </>
          ))
        )}
      </div>

      {/* Back Lavatory Row */}
      <div className="flex justify-between mt-4">
        <Lavatory position="back" />
        <Lavatory position="back" />
      </div>
    </div>
  );
};

export default SeatMap;
